import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpCircleOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 512,
	height: 512,
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M256,80A176,176,0,1,0,432,256,176,176,0,0,0,256,80Z",
			fill: "none",
			stroke: "#fff",
			strokeMiterlimit: 10,
			strokeWidth: "32px"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200,202.29s.84-17.5,19.57-32.57C230.68,160.77,244,158.18,256,158c10.93-.14,20.69,1.67,26.53,4.45,10,4.76,29.47,16.38,29.47,41.09,0,26-17,37.81-36.37,50.8S251,281.43,251,296",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeMiterlimit: 10,
			strokeWidth: "28px"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 250,
			cy: 348,
			r: 20,
			fill: "#fff"
		})
	]
});
export default SvgHelpCircleOutline;
